export default "__VITE_ASSET__ClSTyl8t__"